<template>
  <section class="specialist-history">
    <header class="specialist-history__header">
      <span><i :class="group.icon"></i></span>
      <div>
        <h3>Riwayat {{ group.label }}</h3>
        <p>{{ group.items.length }} catatan layanan ditemukan untuk pasien ini.</p>
      </div>
    </header>

    <div class="specialist-history__list">
      <router-link
        v-for="item in group.items"
        :key="item.id"
        :to="item.route"
        class="specialist-history__item"
        title="Buka detail layanan"
      >
        <div class="specialist-history__date">
          <strong>{{ dateDay(item.date) }}</strong>
          <span>{{ dateMonthYear(item.date) }}</span>
        </div>
        <div class="specialist-history__content">
          <div class="specialist-history__title">
            <div>
              <h4>{{ item.title }}</h4>
              <span v-if="item.reference">{{ item.reference }}</span>
            </div>
            <span class="specialist-history__status" :class="`is-${statusClass(item.status)}`">
              {{ statusLabel(item.status) }}
            </span>
          </div>
          <p>{{ item.summary || 'Tidak ada ringkasan klinis.' }}</p>
          <small v-if="item.meta">{{ item.meta }}</small>
        </div>
        <i class="fas fa-chevron-right specialist-history__arrow" aria-hidden="true"></i>
      </router-link>
    </div>
  </section>
</template>

<script>
import moment from 'moment'

export default {
  name: 'SpecialistHistoryPanel',
  props: {
    group: { type: Object, required: true }
  },
  methods: {
    dateDay(value) {
      return value ? moment(value).format('DD') : '--'
    },
    dateMonthYear(value) {
      return value ? moment(value).locale('id').format('MMM YYYY') : 'Tanpa tanggal'
    },
    statusClass(value) {
      return String(value || 'unknown').toLowerCase().replace(/[^a-z0-9]+/g, '-')
    },
    statusLabel(value) {
      const labels = {
        draft: 'Draft', final: 'Final', planned: 'Direncanakan', active: 'Aktif',
        on_hold: 'Ditunda', completed: 'Selesai', proposed: 'Diajukan', accepted: 'Disetujui',
        in_progress: 'Berjalan', cancelled: 'Dibatalkan', void: 'Dibatalkan'
      }
      return labels[value] || value || 'Tidak diketahui'
    }
  }
}
</script>

<style scoped>
.specialist-history { padding: 1.25rem 0 .25rem; min-width: 0; }
.specialist-history__header { display: flex; align-items: center; gap: .85rem; margin-bottom: 1rem; }
.specialist-history__header > span { display: grid; place-items: center; flex: 0 0 46px; width: 46px; height: 46px; border-radius: 13px; background: #e8f7f5; color: #168f89; font-size: 1.1rem; }
.specialist-history__header h3 { margin: 0 0 .2rem; color: #213b55; font-size: 1.05rem; font-weight: 800; }
.specialist-history__header p { margin: 0; color: #7b8b9b; font-size: .8rem; }
.specialist-history__list { display: grid; gap: .75rem; }
.specialist-history__item { position: relative; display: grid; grid-template-columns: 64px minmax(0, 1fr); gap: .85rem; padding: 1rem 2.5rem 1rem 1rem; border: 1px solid #e3ebf1; border-radius: 14px; background: #fff; color: inherit; text-decoration: none; transition: border-color .16s ease, box-shadow .16s ease, transform .16s ease; }
.specialist-history__item:hover { border-color: #48aaa5; box-shadow: 0 8px 20px rgba(31,77,97,.09); color: inherit; text-decoration: none; transform: translateY(-1px); }
.specialist-history__arrow { position: absolute; top: 50%; right: 1rem; color: #168f89; transform: translateY(-50%); }
.specialist-history__date { display: flex; align-items: center; flex-direction: column; justify-content: center; border-radius: 10px; background: #f1f7fa; color: #31516d; text-align: center; }
.specialist-history__date strong { font-size: 1.25rem; line-height: 1; }
.specialist-history__date span { margin-top: .25rem; font-size: .62rem; font-weight: 700; text-transform: uppercase; }
.specialist-history__content { min-width: 0; }
.specialist-history__title { display: flex; align-items: flex-start; justify-content: space-between; gap: .75rem; }
.specialist-history__title h4 { margin: 0; color: #213b55; font-size: .9rem; font-weight: 800; }
.specialist-history__title div > span { color: #718397; font-size: .7rem; font-weight: 700; overflow-wrap: anywhere; }
.specialist-history__content p { margin: .55rem 0 .35rem; color: #53697d; font-size: .78rem; white-space: pre-line; overflow-wrap: anywhere; }
.specialist-history__content small { color: #7b8b9b; font-weight: 700; }
.specialist-history__status { flex: 0 0 auto; padding: .3rem .55rem; border-radius: 99px; background: #edf2f5; color: #5f7284; font-size: .64rem; font-weight: 800; }
.specialist-history__status.is-final,
.specialist-history__status.is-completed,
.specialist-history__status.is-accepted,
.specialist-history__status.is-active { background: #e8f7f1; color: #16805f; }
.specialist-history__status.is-cancelled,
.specialist-history__status.is-void { background: #fff0f0; color: #c94c4c; }
.specialist-history__status.is-in-progress,
.specialist-history__status.is-proposed,
.specialist-history__status.is-planned { background: #fff7e5; color: #a66b00; }
@media (max-width: 575.98px) {
  .specialist-history__item { grid-template-columns: 48px minmax(0, 1fr); padding: .75rem; }
  .specialist-history__title { flex-direction: column; }
}
</style>
